module.exports = __webpack_public_path__ + "img/lhjt-icon.a8a7a02d.png";